<div class="json-tree">
  <div class="json-tree__head">
    @if (label()) {
      @if (isHeading3()) {
        <h3>{{ label() | translate }}</h3>
      } @else {
        <h4>{{ label() | translate }}</h4>
      }
    }
    <div class="json-tree__actions">
      @if (tree()) {
        <app-secondary-button title="Expand all" icon="pi pi-plus" size="small" (action)="expandAll()"></app-secondary-button>
        <app-secondary-button title="Collapse all" icon="pi pi-minus" size="small" (action)="collapseAll()"></app-secondary-button>
        <msf-input
          [model]="search()"
          (modelChange)="setSearch($event)"
          type="search"
          [placeholder]="'Search JSON' | translate"
        ></msf-input>
      }
      <app-secondary-button
        [title]="copyTitle()"
        [icon]="copyIcon()"
        size="small"
        [disable]="!canCopy()"
        (action)="copy()"
      ></app-secondary-button>
    </div>
  </div>

  @if (tree()) {
    @if (view(); as root) {
      <div class="json-tree__body">
        <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: root }"></ng-container>
      </div>
    } @else {
      <p class="empty-state compact">{{ 'No JSON matches' | translate }}</p>
    }
  } @else {
    <pre><code>{{ text() }}</code></pre>
  }
</div>

<ng-template #nodeTemplate let-node>
  <div class="json-tree__row" [style.padding-left.px]="node.depth * 16">
    @if (node.expandable) {
      <button type="button" class="json-tree__toggle" (click)="toggle(node.id)" [attr.aria-expanded]="node.open">
        <i class="pi" [class.pi-chevron-down]="node.open" [class.pi-chevron-right]="!node.open" aria-hidden="true"></i>
      </button>
    } @else {
      <span class="json-tree__toggle json-tree__toggle--leaf"></span>
    }
    <span class="json-tree__key">{{ node.keyLabel }}</span>
    @if (node.downloadUrl) {
      <a class="json-tree__value json-tree__download" [href]="node.downloadUrl" [title]="'Download' | translate">{{ node.valueLabel }}</a>
    } @else if (node.valueLabel) {
      <span class="json-tree__value">{{ node.valueLabel }}</span>
    }
    @if (node.note) {
      <span class="json-tree__note">{{ node.note }}</span>
    }
  </div>
  @if (node.open) {
    @for (child of node.children; track child.id) {
      <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: child }"></ng-container>
    }
  }
</ng-template>
